module.exports = __webpack_public_path__ + "static/media/poiissehotel.92415869.png";